import { makeStyles } from '@material-ui/core'
import React from 'react'
import {
  useTranslate,
  MenuItemLink,
  ReduxState,
  ResourceDefinition,
  getResources,
} from 'react-admin'
import { useSelector } from 'react-redux'
import { ResourceName } from '../../core/ResourceName'
import { MenuItemProps } from './MenuItem'

const useStyles = makeStyles((theme) => ({
  sidebarIsOpen: {
    '& > div': {
      paddingLeft: theme.spacing(2),
    },
  },
}))

interface MenuSubitemProps extends MenuItemProps {
  sidebarOpen?: boolean
}

const MenuSubitem = (props: MenuSubitemProps) => {
  const { resource, icon, to, label, sidebarOpen } = props
  const translate = useTranslate()
  const classes = useStyles()

  const availableResources = new Set(
    useSelector<ReduxState, ResourceDefinition[]>(getResources).map(
      (r) => r.name as ResourceName,
    ),
  )

  return (
    <>
      {availableResources.has(resource) && (
        <MenuItemLink
          className={sidebarOpen ? classes.sidebarIsOpen : undefined}
          to={to || `/${resource}`}
          primaryText={translate(label || `resources.${resource}.name`)}
          leftIcon={icon}
        />
      )}
    </>
  )
}

export default MenuSubitem
